export default "__VITE_ASSET__B_I4$YAX__"